<template lang="pug">
  .layout#app
    component(
      class="layout__header"
      :is="tenantComponents.header"
      :newYearFeatureEnabled="newYearFeatureEnabled"
      :newYearLogoUrl="newYearLogoUrl"
    )
    router-view
    .layout__footer(v-if="!isTenantDefault")
      component(:is="tenantComponents.footer")
    Onboarding(v-if="isTenantDefault")
    Alerts
    ConfirmDialog
</template>

<script>
import Header from '@/components/Header/tenants/rr/Header.vue'
import HeaderNbd from '@/components/Header/tenants/nbd/Header.vue'
import HeaderTopliga2 from '@/components/Header/tenants/topliga2/Header.vue'
import FooterNbd from '@/components/Footer/tenants/nbd/Footer.vue'
import FooterTopliga2 from '@/components/Footer/tenants/topliga2/Footer.vue'
import Alerts from '@/components/Alerts.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import Onboarding from '@/components/Onboarding.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { getCdnUrl } from '@rr-components/shared-fsd/shared/utils/config'

export default {
  components: {
    Header,
    HeaderNbd,
    HeaderTopliga2,
    FooterNbd,
    FooterTopliga2,
    Alerts,
    ConfirmDialog,
    Onboarding
  },
  computed: {
    ...mapGetters('features', ['newYearFeatureEnabled']),
    tenant () {
      return this.$root.$env.VUE_APP_TENANT
    },
    isTenantDefault () {
      return this.tenant === 'rr'
    },
    tenantComponents () {
      const namesComponents = {
        header: '',
        footer: ''
      }
      switch (this.tenant) {
        case 'nbd':
          namesComponents.header = 'HeaderNbd'
          namesComponents.footer = 'FooterNbd'
          break
        case 'topliga2':
          namesComponents.header = 'HeaderTopliga2'
          namesComponents.footer = 'FooterTopliga2'
          break
        default:
          namesComponents.header = 'Header'
      }
      return namesComponents
    },
    newYearLogoUrl () {
      return `${getCdnUrl()}rr/assets/img/rr-logo-newyear.svg`
    }
  },
  methods: {
    ...mapActions('user', ['getUser']),
    ...mapActions('clubs', ['getClubsFilters']),
    ...mapMutations('club', ['setMembersLinkAvailable']),
    ...mapActions('features', ['setTenant', 'setupFeatures']),
    detectTouch () {
      let isTouch = false
      if ('ontouchstart' in document.documentElement) {
        isTouch = true
      }
      this.$root.isTouch = isTouch
      this.$root.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
      this.$root.android = /android/i.test(navigator.userAgent)
      document.body.className += isTouch ? ' touch' : ' no-touch'
    }
  },
  mounted () {
    this.detectTouch()
    const isIE = /MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)
    if (isIE) {
      document.body.className += ' ie'
    }
    this.setMembersLinkAvailable(this.$getTenantIsMemberLinks())
    this.setTenant(this.tenant)
    this.setupFeatures()
  },
  created () {
    this.getUser()
    this.getClubsFilters()
    this.$root.$modals = {}
    this.$root.$env = process.env
  }
}
</script>
